<div *ngIf="showLandingPAge" class="login-form-container">
<div class="login-form">
    <div>
        <div class="login-form-heading">
            <img src="../../../assets/images/chatbot-icon.svg" alt = "logo"/>
            <h1>Log in to your account</h1>
        </div>
        <p>(with your DSO credentials)</p>
    </div>
    <form (ngSubmit)="onLogin()">
        <div class="from-input-container">
            <label for="username">Email ID</label>
            <input type="text" id="username" name="username" autocomplete="email" [(ngModel)]="username" [disabled]="isLoading" class="login-form-input">
        </div>
        <div class="from-input-container">
            <label for="password">Password</label>
            <div class="password-field">
                <input
                    *ngIf="!passwordVisible"
                    type="password"
                    id="password"
                    name="password"
                    autocomplete="current-password"
                    [(ngModel)]="password"
                    [disabled]="isLoading"
                    class="login-form-input login-form-input--password">
                <input
                    *ngIf="passwordVisible"
                    type="text"
                    id="password"
                    name="password"
                    autocomplete="off"
                    [(ngModel)]="password"
                    [disabled]="isLoading"
                    class="login-form-input login-form-input--password">
                <button
                    type="button"
                    class="password-toggle"
                    (click)="togglePasswordVisible()"
                    [disabled]="isLoading"
                    [attr.aria-label]="passwordVisible ? 'Hide password' : 'Show password'"
                    [attr.aria-pressed]="passwordVisible">
                    <i class="fa-solid" [ngClass]="passwordVisible ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
                </button>
            </div>
        </div>
        <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
        <button type="submit" [disabled]="isLoading" class="login-button">
            {{ isLoading ? 'Logging in...' : 'Log in' }}
        </button>
    </form>
</div>
</div>
